export default __webpack_public_path__ + "static/media/LinkedIn24.cc8824a3.jpg";